import { Dayjs, dayjs } from '@contra/date';

// See: https://day.js.org/docs/en/customization/relative-time
const suffixMap = {
  'a day': '1d ago',
  'a few seconds': 'now',
  'a minute': '1m ago',
  'a month': '1mo ago',
  'an hour': '1h ago',
  'a year': '1y ago',
  ' days': 'd ago',
  ' hours': 'h ago',
  ' minutes': 'm ago',
  ' months': 'mo ago',
  ' years': 'y ago',
};

const shortSuffixMap = {
  'a day': '1d',
  'a few seconds': 'now',
  'a minute': '1m',
  'a month': '1mo',
  'an hour': '1h',
  'a year': '1y',
  ' days': 'd',
  ' hours': 'h',
  ' minutes': 'm',
  ' months': 'mo',
  ' years': 'y',
};

export const getShortRelativeTime = (
  date?: Date | Dayjs | null | number | string | undefined,
  useShortSuffix: boolean = false,
  normalDateCutoffDays?: number,
) => {
  if (
    normalDateCutoffDays &&
    dayjs(date).isBefore(dayjs().subtract(normalDateCutoffDays, 'day'))
  ) {
    // check that the date is within the last year, if so, don't show the year
    if (dayjs(date).isAfter(dayjs().subtract(1, 'year'))) {
      return dayjs(date).format('MMM D');
    }

    return dayjs(date).format('MMM D, YYYY');
  }

  const originalString = dayjs(date).fromNow(true);

  const mapToUse = useShortSuffix ? shortSuffixMap : suffixMap;

  for (const suffix in mapToUse) {
    if (originalString.includes(suffix)) {
      return originalString.replace(suffix, mapToUse[suffix]);
    }
  }

  return originalString;
};
